import React, { memo } from 'react';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { Grid, IconButton, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface NumberPickerProps {
  id: string;
  value: number;
  min?: number;
  max?: number;
  edge?: 'start' | 'end';
  dense?: boolean;
  disabled?: boolean;
  onIncrement: () => void;
  onDecrement: () => void;
  maxAmountReached: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    color: '#4E6DF5',
  },
  value: {
    padding: theme.spacing(0.5),
  },
  dense: {
    marginTop: -12,
    marginBottom: -12,
  },
}));

const NumberPicker: React.FC<React.PropsWithChildren<NumberPickerProps>> = (props) => {
  const { value, max, min = 0, edge, dense, disabled, onIncrement, onDecrement, maxAmountReached, ...rest } = props;
  const { classes, cx } = useStyles();

  return (
    <Grid container alignItems="center" {...rest}>
      <Grid item>
        <IconButton
          className={cx({ [classes.dense]: dense, [classes.root]: true })}
          disabled={(Number.isInteger(min) && value === min) || disabled}
          color="primary"
          edge={edge === 'start' ? edge : false}
          onClick={onDecrement}
          size="large"
        >
          <RemoveCircleOutlineOutlinedIcon />
        </IconButton>
      </Grid>
      <Grid item xs>
        <Typography className={classes.value} variant="h6">
          {value}
        </Typography>
      </Grid>
      <Grid item>
        <IconButton
          className={cx({ [classes.dense]: dense, [classes.root]: true })}
          disabled={(Number.isInteger(max) && value === max) || disabled || maxAmountReached}
          color="primary"
          edge={edge === 'end' ? edge : false}
          onClick={onIncrement}
          size="large"
        >
          <AddCircleOutlineOutlinedIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default memo(NumberPicker);
